<template>
    <div id="fd-zjxx">
        <my-title the-title="证据信息"/>
            <van-cell-group class="fd-com-scroll">
                <van-field
                    v-model="formData.nZjlxTxt"
                    class="special-readonly"
                    required
                    clearable
                    readonly
                    label="证据类型"
                    right-icon="arrow"
                    placeholder="请选择证据类型"
                    @click="showZjbqsx = true"
                ></van-field>
                <van-popup v-model="showZjbqsx" position="bottom">
                    <van-picker
                        show-toolbar
                        :columns="codeZjList"
                        :default-index="0"
                        @cancel="showZjbqsx = false"
                        @confirm="onSxsmConfirm"
                    ></van-picker>
                </van-popup>
                <van-field v-model.lazy.trim="formData.cZjmc" required label="证据名称" placeholder="请输入证据名称"/>
                <van-field
                    required
                    readonly
                    label="原件原物">
                    <van-radio-group v-model="formData.nYjwj" slot="input">
                        <van-radio name="1">
                            是
                        </van-radio>
                        <van-radio name="2">
                            否
                        </van-radio>
                    </van-radio-group>
                </van-field>
                <van-field v-model.lazy.trim="formData.cZjly" required label="证据来源" placeholder="证据来源"/>
                <van-field
                    class="fd-textarea"
                    type="textarea"
                    rows="2"
                    show-word-limit
                    autosize
                    :rules="[{ required: true, message: '请输入证据说明' }]"
                    v-model="formData.cZjsm"
                    label="证据说明"
                    maxlength="200"
                    placeholder="请输入证据说明"
                />

            </van-cell-group>

            <div class="fd-com-btn-container">
                <van-button
                    v-if="formData.zjxxId"
                    type="info"
                    round
                    @click="addAndReturn"
                >
                    确定
                </van-button>
                <van-button
                    v-if="!formData.zjxxId"
                    type="info"
                    round
                    plain
                    @click="addAndReturn"
                >
                    添加
                </van-button>
                <van-button
                    v-if="!formData.zjxxId"
                    type="info"
                    round
                    @click="addAndContinue"
                >
                    确认并继续添加
                </van-button>
            </div>
    </div>
</template>

<script>
import MyTitle from '../../../components/common/myTitle';
import {mapState} from "vuex";
import validate from "@/utils/validator/validator";
import {addXcxZj,getXcxZj} from '../../../api/guarantee';
import {zjlxType} from "../../../filters/index";
import {czjmcRule, czjlyRule} from "@/utils/validator/rules";

export default {
    name: "addXwxx",
    components: {
        MyTitle
    },
    data() {
        return {
            checked: '1',
            checkRadioFlag: false,
            formData:{
                zjxxId: null, // id
                nZjlx: 1,
                nZjlxTxt:'当事人陈述',
                cZjsm:'',
                cZjmc: '',
                nYjwj: '1',
                nYjwjTxt: '是',
                cZjly: ''
            },
            myRules: [],
            showZjbqsx:false,
            codeZjList: [
                { text: '当事人陈述', value: '1' },
                { text: '被告人陈述', value: '2' },
                { text: '犯罪嫌疑人、被告人供述和辩解', value: '3' },
                { text: '书证', value: '4' },
                { text: '物证', value: '5' },
                { text: '视听资料', value: '6' },
                { text: '电子数据', value: '7' },
                { text: '证人证言', value: '8' },
                { text: '鉴定意见', value: '9' },
                { text: '勘验、检查、辨认、侦查实验等笔录', value: '10' },
                { text: '其他', value: '255' },
            ]
        };
    },
    computed: {
        ...mapState(['applyPreservation']),
    },
    methods: {
        onSxsmConfirm: function(item) {
            this.formData.nZjlx = item.value;
            this.formData.nZjlxTxt = item.text;
            this.showZjbqsx = false;
            console.log('--onSxsmConfirm 111',item);
            console.log('--onSxsmConfirm 222',this.formData);
        },
        //组装提交数据
        params() {
            let {zjxxId, nZjlx, cZjmc, nYjwj, cZjly, cZjsm} = this.formData;
            return {cId:zjxxId, nZjlx, cZjmc, nYjwj, cZjly, cZjsm}
        },
        validateFormData(){
            // 校验规则
            let descriptor = {};
            descriptor.cZjmc = czjmcRule;
            descriptor.cZjly= czjlyRule;
            return validate(descriptor, this.formData);
        },
        onSubmit(fn){
            console.log('--数据提交 111',this.formData,this.params());
            this.validateFormData().then(() => {
                let currentBqId = JSON.parse(sessionStorage.getItem("currentBqid"));
                console.log('--数据提交222');
                // return false;
                addXcxZj({bqid:currentBqId},this.params()).then((res)=>{
                    console.log('--addXcxZj 123',res);
                    if (res.code === 200) {
                        this.$notify({'type': 'success', 'message': '操作成功'});
                    } else {
                        this.$notify(res.message);
                    }
                    fn();
                }).catch(() => {  console.log(error) });
            });
        },
        addAndReturn(){
            this.onSubmit(()=>{
                this.$router.push("/preservationInfo");
            });
        },
        addAndContinue(){
            this.onSubmit(()=> {
                setTimeout(() => {
                    window.location.reload();
                }, 500);
            });
        },
        initData(){
            getXcxZj({id:this.formData.zjxxId}).then(res=> {
                console.log('--initData 123',res);
                var data = res.data;
                this.formData.nZjlx = data.nZjlx;
                this.formData.nZjlxTxt = zjlxType(data.nZjlx);
                this.formData.cZjmc = data.cZjmc;
                this.formData.nYjwj = data.nYjwj.toString();
                this.formData.cZjly = data.cZjly;
                this.formData.cZjsm = data.cZjsm;
            });
        }
    },
    created() {
        // this.myRules = new Rules(this.formData)
        console.log('--created zjxx');
        var zjxxId = sessionStorage.getItem("bqZjxxId");
        if(zjxxId){
            this.formData.zjxxId = zjxxId;
            this.initData();
        }
    }
}
</script>

<style lang="less" scoped>

#fd-zjxx{
    width: 100%;
    height: 100%;
    overflow: hidden;

        .fd-textarea{
            height: auto;
        }
}
</style>
